import { render, staticRenderFns } from "./ed-class-change-main-placeholder-modal.component.vue?vue&type=template&id=90d9c5ba&scoped=true&"
import script from "./ed-class-change-main-placeholder-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-change-main-placeholder-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-change-main-placeholder-modal.component.scss?vue&type=style&index=0&id=90d9c5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d9c5ba",
  null
  
)

export default component.exports